import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormControl, AbstractControl } from '@angular/forms';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { NbDialogService, NbGlobalPhysicalPosition, NbGlobalPosition, NbToastrService } from '@nebular/theme';
import { Store, select } from '@ngrx/store';
import { NbComponentStatus } from '@nebular/theme';
import * as fromAuth from '@app-stores/reducers/auth';
import * as Auth from '@app-stores/actions/auth.action';
import { AuthService } from '@app-services/auth.service';
import { TranslationService } from "@app-services/translation.service";


@Component({
	selector: 'crm-reset-password',
	templateUrl: './reset-password.component.html',
	styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

	form: UntypedFormGroup;

	loading = false;
	errorMessage = '';
	successMessage = '';
	currUser;
	private _duration = 2000;
	private _position: NbGlobalPosition = NbGlobalPhysicalPosition.TOP_RIGHT;
	private _preventDuplicates = false;
	getChangePasswordPending$ = this._store.pipe(select(fromAuth.getChangePasswordPending));
	getChangePasswordSuccess$ = this._store.pipe(select(fromAuth.getChangePasswordSuccess));
	getChangePasswordError$ = this._store.pipe(select(fromAuth.getChangePasswordError));

	submitted = false;

	// Private
	private _viewInited: boolean = false;
	private _unsubscribeAll: Subject<any>;


	constructor(
		private _router: Router,
		private _route: ActivatedRoute,
		private _formBuilder: UntypedFormBuilder,
		private _store: Store<fromAuth.AuthState>,
		private _toastrService: NbToastrService,
		private auth: AuthService,
		private _translationService: TranslationService,


	) {
		// Set the private defaults
		this.form = this._formBuilder.group({
			oldPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(255)]],
			newPassword: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(255)]],
			newPasswordConfirm: ['', [Validators.required, confirmPassword]],
		});
		this.currUser = JSON.parse(localStorage.getItem('user'));
		this._unsubscribeAll = new Subject();
	}

	ngOnInit() {
		this._viewInited = true;
	}

	resetPassword() {
		if (this.form.invalid)
			return;
		this.submitted = true;
		this.errorMessage = null;

		this.auth.changePassword(
			{
				uuid: this.currUser.uuid,
				oldPassword: this.form.value.oldPassword,
				newPassword: this.form.value.newPassword,
			}).pipe(takeUntil(this._unsubscribeAll)).subscribe((res: any) => {
				if (res.success == false) {
					// this.showToast(NbToastStatus.SUCCESS, 'Success', res.message);
					this.showToast('danger', this._translationService.translate('Common.Failed'), this._translationService.translate(`Common.${res.message}`));
				} else {
					localStorage.removeItem('access_token');
					localStorage.setItem('access_token', res.access_token);
					this.showToast('success', this._translationService.translate('Common.Success'), this._translationService.translate(`Common.${res.message}`));
					this._router.navigate(['/#/pages/home/view'])
				}
			}, (err) => {

			});

	}

	ngOnDestroy(): void {
		// Unsubscribe from all subscriptions

		this._unsubscribeAll.next();
		this._unsubscribeAll.complete();
	}
	private showToast(type: NbComponentStatus, title: string, body: string) {
		const config = {
			status: type,
			destroyByClick: true,
			duration: this._duration,
			hasIcon: true,
			position: this._position,
			preventDuplicates: this._preventDuplicates,
		};
		const titleContent = title ? `. ${title}` : '';

		this._toastrService.show(
			body,
			`${titleContent}`,
			config);
	}
}

function confirmPassword(control: AbstractControl): any {
	if (!control.parent || !control) {
		return;
	}

	const password = control.parent.get('newPassword');
	const passwordConfirm = control.parent.get('newPasswordConfirm');

	if (!password || !passwordConfirm) {
		return;
	}

	if (passwordConfirm.value === '') {
		return;
	}

	if (password.value !== passwordConfirm.value) {
		return {
			passwordsNotMatch: true,
		};
	}
}
